import { useState } from 'react';
import { useDebounce } from 'react-use';
import useSWR from 'swr';
import { UseSearchResponse } from '@/hooks/use-search/use-search.types';
import { COLLECTION_MECHANIC } from '../../models/collection-mechanic/collection-mechanic.types';
import fetcher from '../../utils/fetcher';

const useSearch = (
  collection_method?: COLLECTION_MECHANIC | null,
  defaultValue = '',
  disable_clo?: boolean,
): UseSearchResponse => {
  const [searchValue, setSearchValue] = useState(defaultValue);
  const [debouncedValue, setDebouncedValue] = useState('');

  const handleDebounce = () => setDebouncedValue(searchValue);
  useDebounce(handleDebounce, 250, [searchValue]);

  const collectionMethod = collection_method
    ? `&collection_method=${collection_method}`
    : '';

  const disableCLO = disable_clo ? `&disable_clo=${disable_clo}` : '';

  const { data, isLoading } = useSWR(
    () =>
      debouncedValue.length > 1
        ? `/api/search?value=${encodeURIComponent(
            debouncedValue,
          )}${collectionMethod}${disableCLO}`
        : null,
    fetcher,
  );

  const searchResults = data?.results ?? [];

  const errorPartnerResponse =
    data?.sources?.merchantResults?.status &&
    data?.sources?.merchantResults?.status !== 'fulfilled';

  return {
    searchResults,
    searchValue,
    setSearchValue,
    isLoading,
    debouncedValue,
    errorPartnerResponse,
  };
};

export default useSearch;
